import { useLazyLoadQuery } from "react-relay";
import { moduleRatingSummary_Query } from "@generated/moduleRatingSummary_Query.graphql";
import { MODULE_RATING_QUERY } from "./module-rating-summary.graphql";
import { StarText } from "./module-rating-summary.styles";
import { ModuleRatingSummaryProps } from "./module-rating-summary.types";
import { StarIconLeftFrame } from "./parts/StarIconLeftFrame";

export const ModuleRatingSummaryComponent = ({
	nodeRef,
	isAlwaysVisible,
}: ModuleRatingSummaryProps) => {
	const query = useLazyLoadQuery<moduleRatingSummary_Query>(
		MODULE_RATING_QUERY,
		{
			nodeRef: nodeRef,
		},
		{ fetchPolicy: "network-only" },
	);
	const moduleRating = query.ModuleRating.ModuleRatingNodeSummary;
	return (
		<>
			{moduleRating.sum >= 5 || isAlwaysVisible ? (
				<>
					<StarIconLeftFrame />
					<StarText className="ml-2 mr-1">
						{moduleRating.average.toFixed(1).replace(".", ",")}
					</StarText>
					<StarText>({moduleRating.sum})</StarText>
				</>
			) : (
				<></>
			)}
		</>
	);
};
